import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { measurementActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const Measurements = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const measurements = useSelector((state) => state.measurements);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "name",
      headerName: "Name",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "code",
      headerName: "Code",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      hide: true,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 150,
      hide: true,
    },
  ];

  const recordIdentifier = "name";

  useEffect(() => {
    dispatch(measurementActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {measurements && (
        <DataTable
          loading={measurements?.loading}
          rows={measurements?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="measurementActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default Measurements;